function alertCheckboxParameterController(){
    const $ctrl = this;

    $ctrl.$onInit = function() {
        if ($ctrl.model == null || $ctrl.model === '' || isNaN($ctrl.model)) {
            $ctrl.model = "0";
        } else {
            $ctrl.model = String($ctrl.model);
        }
    };

    }


angular
    .module('angus.components')
    .component('alertCheckboxParameter', {
        controller: alertCheckboxParameterController,
        bindings: {
            label: '<',
            name: '@',
            model: '=',
            isRequired: '<',
            isReadOnly: '<',
            decimalLimit: '<?'
        },
        template: `
                <div class="checkbox-wrapper">
                    <input type="checkbox"
                           id="{{$ctrl.name}}"
                           name="{{$ctrl.name}}"
                           ng-required="$ctrl.isRequired"
                           ng-disabled="$ctrl.isReadOnly"
                           ng-model="$ctrl.model"
                           ng-true-value="'1'"
                           ng-false-value="'0'"
                           >

                    <label for="{{$ctrl.name}}">
                        {{$ctrl.label || 'Label'}} <span class="red" ng-if="$ctrl.isRequired">*</span>
                    </label>
                </div>`,
    });